var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
import { ItemBase } from '../../../../models/item/item-base';
var KtsConstructionTaskService = /** @class */ (function (_super) {
    __extends(KtsConstructionTaskService, _super);
    function KtsConstructionTaskService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this.visitComps = [];
        return _this;
    }
    KtsConstructionTaskService.prototype.getPartnerCompany = function (id) {
        this.baseUrl = '/v1/gen/project-partner-company-api?query={"predicateList":[{"name":"project_m.id","value":"' + id + '","operator":"eq"}],"orderByList":[{"name":"id","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.partner_company_m_id, display: item.partner_company_name });
            }
            return options;
        }));
    };
    KtsConstructionTaskService.prototype.getGenre = function () {
        this.baseUrl = '/v1/gen/documents-genre-service?query={"orderByList":[{"name":"id","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.id, display: item.name });
            }
            return options;
        }));
    };
    KtsConstructionTaskService.prototype.sortItems = function (items, key) {
        if (key === void 0) { key = 'disp_order'; }
        items.sort(function (a, b) {
            if (a[key] < b[key]) {
                return -1;
            }
            if (a[key] > b[key]) {
                return 1;
            }
            return 0;
        });
    };
    KtsConstructionTaskService.prototype.sortDatetime = function (items) {
        items.sort(function (a, b) {
            var a_date = new Date(a.visiting_scheduled_date);
            var b_date = new Date(b.visiting_scheduled_date);
            if (a_date < b_date) {
                return -1;
            }
            if (a_date > b_date) {
                return 1;
            }
            return 0;
        });
    };
    KtsConstructionTaskService.prototype.checkItem = function (rec) {
        var items = rec['items'] || [];
        var check = true;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            if (item.construction_report && item.construction_report.length > 0) {
                for (var _a = 0, _b = item.construction_report; _a < _b.length; _a++) {
                    var report = _b[_a];
                    if (!this.colservice.checkVal(report.visiting_scheduled_date) || !this.colservice.checkVal(report.leaving_scheduled_date) || !this.checkReportStatus(report)) {
                        check = false;
                        break;
                    }
                }
            }
            if (!check) {
                break;
            }
        }
        if (!check) {
            this.colservice.addError(this.visitComps);
        }
        return check;
    };
    KtsConstructionTaskService.prototype.checkReportStatus = function (report) {
        return (this.colservice.checkVal(report.leaving_actual_date) && !this.colservice.checkVal(report.status) ? false : true);
    };
    KtsConstructionTaskService.prototype.checkDocuments = function (rec) {
        var items = rec['items'] || [];
        var check = true;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            if (item['$type'] === "delete" /* Delete */) {
                continue;
            }
            if (!this.colservice.checkItemVal(Object.assign(new ItemBase(), { controlType: 'file' }), item.file)) {
                check = false;
                break;
            }
        }
        return check;
    };
    KtsConstructionTaskService.prototype.resetVisitComp = function () {
        this.visitComps = [];
    };
    KtsConstructionTaskService.prototype.setVisitComp = function (compName) {
        this.visitComps.push(compName);
    };
    KtsConstructionTaskService.prototype.getVisitComp = function () {
        return this.visitComps;
    };
    KtsConstructionTaskService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsConstructionTaskService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return KtsConstructionTaskService;
}(ContentBaseService));
export { KtsConstructionTaskService };
var Task = /** @class */ (function () {
    function Task() {
        this.task_other_field_m = [];
        this.is_complete = false;
    }
    return Task;
}());
export { Task };
var TaskOtherField = /** @class */ (function () {
    function TaskOtherField() {
    }
    return TaskOtherField;
}());
export { TaskOtherField };
var ConstructionTask = /** @class */ (function () {
    function ConstructionTask() {
        this.$type = "post" /* Post */;
        this.is_ok = null;
        this.necessity = true;
        this.is_complete = false;
        this.construction_report = [];
        this.construction_documents = [];
        this.delivery_destination = new DeliveryDestination();
    }
    return ConstructionTask;
}());
export { ConstructionTask };
var ConstructionTaskOtherField = /** @class */ (function () {
    function ConstructionTaskOtherField() {
        this.$type = "post" /* Post */;
    }
    return ConstructionTaskOtherField;
}());
export { ConstructionTaskOtherField };
var ConstructionReport = /** @class */ (function () {
    function ConstructionReport() {
    }
    return ConstructionReport;
}());
export { ConstructionReport };
var ConstructionDocuments = /** @class */ (function () {
    function ConstructionDocuments() {
    }
    return ConstructionDocuments;
}());
export { ConstructionDocuments };
var DeliveryDestination = /** @class */ (function () {
    function DeliveryDestination() {
    }
    return DeliveryDestination;
}());
export { DeliveryDestination };
var Template = /** @class */ (function () {
    function Template() {
        this.cols = [];
        this.necessity = false;
        this.datetime = false;
        this.date = false;
        this.upload = false;
    }
    return Template;
}());
var TaskTemplate = /** @class */ (function () {
    function TaskTemplate(msg, readonly, mode, fileOptions) {
        this.file = new Template();
        this.confirm = new Template();
        this.standard = new Template();
        this.onsite = new Template();
        this.onsite_notime = new Template();
        this.construction = new Template();
        this.estimate = new Template();
        this.order = new Template();
        this.completion = new Template();
        this.inspection = new Template();
        this.datetime = [];
        this.date = [];
        this.necessity = {};
        this.upload = [];
        this.uploadConfirm = {};
        this.multiUpload = [];
        var colPlanDate = {
            controlType: 'date',
            label: msg['au.COMPONENTS.label.task_plan_date'],
            key: 'plan_date',
            readonly: (mode === "setting" /* setting */ ? readonly : true)
        };
        var colActDate = {
            controlType: 'date',
            label: msg['au.COMPONENTS.label.task_act_date'],
            key: 'act_date',
            readonly: true
        };
        var confirm = {
            controlType: 'select',
            label: msg['au.COMPONENTS.label.task_is_ok'],
            key: 'is_ok',
            readonly: readonly,
            params: {
                options: [
                    { code: 'true', display: msg['au.COMPONENTS.select.task_ok'] },
                    { code: 'false', display: msg['au.COMPONENTS.select.task_ng'] }
                ]
            }
        };
        this.necessity = {
            controlType: 'select',
            label: msg['au.COMPONENTS.label.task_necessity'],
            key: 'necessity',
            readonly: (mode === "setting" /* setting */ ? readonly : true),
            required: true,
            params: {
                options: [
                    { code: 'true', display: msg['au.COMPONENTS.select.task_necessary'] },
                    { code: 'false', display: msg['au.COMPONENTS.select.task_unnecessary'] }
                ]
            }
        };
        this.datetime = [{
                label: msg['au.COMPONENTS.label.task_datetime'],
                key: 'construction_report',
                readonly: (mode === "setting" /* setting */ ? readonly : true),
                items: [{
                        key: 'id',
                        hidden: true
                    }, {
                        controlType: 'select',
                        label: msg['au.COMPONENTS.label.task_report_status'],
                        key: 'status',
                        readonly: readonly,
                        params: {
                            options: []
                        }
                    }, {
                        label: msg['au.COMPONENTS.label.task_plan_datetime'],
                        required: true,
                        items: [{
                                controlType: 'datetime',
                                key: 'visiting_scheduled_date',
                                readonly: (mode === "setting" /* setting */ ? readonly : true),
                                hidden: ((mode === "progress" /* progress */ || readonly) ? true : false),
                                params: {
                                    range: { from: 'visiting_scheduled_date', to: 'leaving_scheduled_date' }
                                }
                            }, {
                                label: '~',
                                controlType: 'label'
                            }, {
                                controlType: 'datetime',
                                key: 'leaving_scheduled_date',
                                readonly: (mode === "setting" /* setting */ ? readonly : true),
                                hidden: ((mode === "progress" /* progress */ || readonly) ? true : false),
                                params: {
                                    range: { from: 'visiting_scheduled_date', to: 'leaving_scheduled_date' }
                                }
                            }]
                    }, {
                        label: msg['au.COMPONENTS.label.task_arrival_datetime'],
                        readonly: readonly,
                        items: [{
                                controlType: 'datetime',
                                key: 'arrival_actual_date'
                            }]
                    }, {
                        label: msg['au.COMPONENTS.label.task_act_datetime'],
                        readonly: readonly,
                        items: [{
                                controlType: 'datetime',
                                key: 'visiting_actual_date',
                                params: {
                                    range: { from: 'visiting_actual_date', to: 'leaving_actual_date' }
                                }
                            }, {
                                label: '~',
                                controlType: 'label'
                            }, {
                                controlType: 'datetime',
                                key: 'leaving_actual_date',
                                params: {
                                    range: { from: 'visiting_actual_date', to: 'leaving_actual_date' }
                                }
                            }]
                    }]
            }];
        this.date = JSOG.parse(JSON.stringify(this.datetime));
        this.date[0].label = msg['au.COMPONENTS.label.task_date'];
        this.date[0].items[2].label = msg['au.COMPONENTS.label.task_plan_date'];
        this.date[0].items[2].items[0].controlType = 'date';
        this.date[0].items[2].items[2].controlType = 'date';
        this.date[0].items[2].items[0].params['formClass'] = { width: '150' };
        this.date[0].items[2].items[2].params['formClass'] = { width: '150' };
        this.upload = [{
                controlType: 'select',
                label: msg['au.COMPONENTS.label.task_file_genre'],
                key: 'documents_genre_id',
                readonly: readonly,
                params: {
                    options: []
                }
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_file_title'],
                key: 'documents_title',
                readonly: readonly
            }, {
                controlType: 'select',
                label: msg['au.COMPONENTS.label.task_referrer_type'],
                key: 'documents_type',
                readonly: readonly,
                required: true,
                params: {
                    options: []
                }
            }];
        this.uploadConfirm = confirm;
        this.multiUpload = [{
                label: msg['au.COMPONENTS.label.task_file'],
                key: 'construction_documents',
                readonly: readonly,
                items: [{
                        key: 'id',
                        hidden: true
                    }, {
                        controlType: 'file',
                        label: msg['au.COMPONENTS.label.task_file'],
                        key: 'file',
                        readonly: readonly,
                        params: { formClass: { width: '100per' } }
                    }, {
                        key: 'file_name',
                        hidden: true
                    }]
            }];
        this.file = Object.assign(new Template(), {
            note: msg['au.COMPONENTS.label.task_note_file'],
            cols: [colPlanDate, colActDate],
            upload: true,
            necessity: true
        });
        this.construction = this.onsite = Object.assign(new Template(), {
            note: msg['au.COMPONENTS.label.task_note_visit'],
            cols: [{
                    controlType: 'select',
                    label: msg['au.COMPONENTS.label.task_partner_company'],
                    key: 'partner_company_m_id',
                    readonly: (mode === "setting" /* setting */ ? readonly : true),
                    params: {
                        options: []
                    }
                }, {
                    controlType: 'select',
                    label: msg['au.COMPONENTS.label.task_secondary_partner_company'],
                    key: 'secondary_partner_company_m_id',
                    readonly: (mode === "setting" /* setting */ ? readonly : true),
                    params: {
                        options: []
                    }
                }, confirm],
            datetime: true,
            necessity: true
        });
        this.onsite_notime = Object.assign({}, this.onsite, { datetime: false, date: true });
        this.confirm = this.inspection = Object.assign(new Template(), {
            note: msg['au.COMPONENTS.label.task_note_confirm'],
            cols: [colPlanDate, colActDate, confirm],
            necessity: true
        });
        this.estimate = this.order = this.completion = Object.assign(new Template(), {
            note: msg['au.COMPONENTS.label.task_note_material'],
            cols: [colPlanDate, colActDate, {
                    label: msg['au.COMPONENTS.label.task_material'],
                    items: [{
                            label: msg['au.COMPONENTS.label.task_material_label'],
                            controlType: 'label'
                        }]
                }]
        });
        this.standard = Object.assign(new Template(), {
            note: msg['au.COMPONENTS.label.task_note_standard'],
            cols: [colPlanDate, Object.assign({}, colActDate, { readonly: readonly })],
            necessity: true
        });
    }
    return TaskTemplate;
}());
export { TaskTemplate };
//# sourceMappingURL=construction-task.service.js.map